(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kcl-color-selections"] && !Shopify.designMode) return;
  try {
    
  const initColorGallery = (root) => {
    if (root.dataset.colorReady) return;
    const tabs = [...root.querySelectorAll('[data-color-tab]')];
    const panels = [...root.querySelectorAll('[data-color-panel]')];
    if (!tabs.length || !panels.length) return;
    const dialog = root.querySelector('[data-color-dialog]');
    const status = root.querySelector('[data-color-status]');
    const callPick = root.querySelector('[data-color-call-pick]');
    const savedWrap = root.querySelector('[data-color-saved-wrap]');
    const savedList = root.querySelector('[data-color-saved]');
    const savedNote = root.querySelector('[data-color-saved-note]');
    const storageKey = 'kingdom-color-favorites-v1';
    let activePanel = panels[0];
    let activePhoto;
    let savedHashes = [];
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) savedHashes = stored.filter(value => typeof value === 'string').slice(0, 3);
    } catch {}
    root.dataset.colorReady = 'true';
    root.querySelector('[data-color-tabs]').setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
    });
    panels.forEach((panel, index) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabs[index].id);
      panel.querySelectorAll('[data-color-controls],[data-color-enlarge],[data-color-copy],[data-color-save]').forEach(control => control.hidden = false);
    });
    const findPhoto = hash => [...root.querySelectorAll('[data-color-photo]')].find(photo => photo.dataset.hash === hash);
    const persistSaved = () => {
      try { localStorage.setItem(storageKey, JSON.stringify(savedHashes)); } catch {}
    };
    const updateSaveButton = () => {
      const button = activePanel?.querySelector('[data-color-save]');
      if (!button || !activePhoto) return;
      const isSaved = savedHashes.includes(activePhoto.dataset.hash);
      button.dataset.saved = String(isSaved);
      button.textContent = isSaved ? '✓ Saved look' : '☆ Save this look';
      button.setAttribute('aria-pressed', String(isSaved));
    };
    const renderSaved = () => {
      savedHashes = savedHashes.filter(hash => findPhoto(hash)).slice(0, 3);
      savedList.replaceChildren();
      savedWrap.hidden = savedHashes.length === 0;
      savedNote.textContent = savedHashes.length === 3 ? 'Three favorites saved. Remove one to choose another.' : 'Keep up to three favorites handy while we plan together.';
      savedHashes.forEach(hash => {
        const photo = findPhoto(hash);
        const card = document.createElement('div');
        const choice = document.createElement('button');
        const image = photo.querySelector('img').cloneNode(false);
        const label = document.createElement('span');
        const remove = document.createElement('button');
        card.className = 'kcl-colors__saved-card';
        choice.className = 'kcl-colors__saved-choice';
        choice.type = 'button';
        choice.dataset.colorSavedChoice = hash;
        choice.setAttribute('aria-label', 'View ' + photo.dataset.caption);
        image.sizes = '54px';
        image.width = 54;
        image.height = 54;
        image.decoding = 'async';
        image.alt = '';
        image.loading = 'lazy';
        label.textContent = photo.dataset.caption;
        remove.className = 'kcl-colors__saved-remove';
        remove.type = 'button';
        remove.dataset.colorRemove = hash;
        remove.setAttribute('aria-label', 'Remove ' + photo.dataset.caption + ' from saved looks');
        remove.textContent = '×';
        choice.append(image, label);
        card.append(choice, remove);
        savedList.append(card);
      });
      persistSaved();
      updateSaveButton();
    };
    const updateDialog = () => {
      const img = dialog.querySelector('[data-color-dialog-image]');
      img.src = activePhoto.dataset.imageLarge;
      img.alt = activePhoto.dataset.alt;
      dialog.querySelector('[data-color-dialog-caption]').textContent = activePhoto.dataset.caption;
    };
    const selectPhoto = (photo, updateUrl = true, announce = true) => {
      if (!photo) return;
      const panel = photo.closest('[data-color-panel]');
      panels.forEach(item => item.hidden = item !== panel);
      tabs.forEach(tab => {
        const selected = tab.dataset.colorTab === panel.dataset.colorPanel;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      activePanel = panel;
      activePhoto = photo;
      const photos = [...panel.querySelectorAll('[data-color-photo]')];
      photos.forEach(item => {
        if (item === photo) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      const img = panel.querySelector('.kcl-colors__image');
      if (img) {
        img.srcset = photo.dataset.srcset;
        img.src = photo.dataset.image;
        img.alt = photo.dataset.alt;
      }
      panel.querySelector('[data-color-caption]').textContent = photo.dataset.caption;
      panel.querySelector('[data-color-position]').textContent = `${photos.indexOf(photo) + 1} / ${photos.length}`;
      panel.querySelector('[data-color-current]').textContent = photo.dataset.caption;
      callPick.textContent = photo.dataset.caption;
      panel.querySelector('[data-color-copy]').textContent = root.dataset.copyLabel + ' ↗';
      panel.querySelector('[data-color-copy-fallback]').hidden = true;
      updateSaveButton();
      if (dialog.open) updateDialog();
      if (announce) status.textContent = photo.dataset.caption;
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.hash = photo.dataset.hash;
        window.history.replaceState(window.history.state, '', url);
      }
    };
    const selectFromHash = () => {
      const hash = window.location.hash.slice(1);
      const photo = [...root.querySelectorAll('[data-color-photo]')].find(item => item.dataset.hash === hash);
      const panel = panels.find(item => item.id === hash);
      if (photo || panel) selectPhoto(photo || panel.querySelector('[data-color-photo]'), false);
    };
    const changePhoto = (step) => {
      const photos = [...activePanel.querySelectorAll('[data-color-photo]')];
      const next = (photos.indexOf(activePhoto) + step + photos.length) % photos.length;
      selectPhoto(photos[next]);
    };
    root.addEventListener('click', async (event) => {
      const tab = event.target.closest('[data-color-tab]');
      const photo = event.target.closest('[data-color-photo]');
      const step = event.target.closest('[data-color-step]');
      const savedChoice = event.target.closest('[data-color-saved-choice]');
      const removeSaved = event.target.closest('[data-color-remove]');
      const save = event.target.closest('[data-color-save]');
      if (tab) {
        event.preventDefault();
        const panel = panels.find(item => item.dataset.colorPanel === tab.dataset.colorTab);
        selectPhoto(panel.querySelector('[data-color-photo][aria-current="true"]') || panel.querySelector('[data-color-photo]'));
      } else if (photo) {
        event.preventDefault();
        selectPhoto(photo);
      } else if (savedChoice) {
        const savedPhoto = findPhoto(savedChoice.dataset.colorSavedChoice);
        if (savedPhoto) {
          selectPhoto(savedPhoto);
          activePanel.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest'});
        }
      } else if (removeSaved) {
        savedHashes = savedHashes.filter(hash => hash !== removeSaved.dataset.colorRemove);
        renderSaved();
        status.textContent = 'Saved look removed.';
      } else if (save) {
        const hash = activePhoto.dataset.hash;
        if (savedHashes.includes(hash)) {
          savedHashes = savedHashes.filter(value => value !== hash);
          status.textContent = 'Saved look removed.';
        } else if (savedHashes.length >= 3) {
          savedNote.textContent = 'Three favorites saved. Remove one to choose another.';
          status.textContent = 'You can save up to three looks.';
          return;
        } else {
          savedHashes.push(hash);
          status.textContent = activePhoto.dataset.caption + ' saved.';
        }
        renderSaved();
      } else if (step) {
        changePhoto(Number(step.dataset.colorStep));
      } else if (event.target.closest('[data-color-enlarge]')) {
        updateDialog();
        dialog.showModal();
      } else if (event.target.closest('[data-color-close]') || event.target === dialog) {
        dialog.close();
      } else if (event.target.closest('[data-color-copy]')) {
        const selectedPhoto = activePhoto;
        const selectedPanel = activePanel;
        const url = new URL(window.location.href);
        url.hash = selectedPhoto.dataset.hash;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url.href);
          if (activePhoto === selectedPhoto) {
            selectedPanel.querySelector('[data-color-copy]').textContent = root.dataset.copiedLabel;
            status.textContent = root.dataset.copiedLabel;
          }
        } catch {
          const fallback = selectedPanel.querySelector('[data-color-copy-fallback]');
          const input = fallback.querySelector('input');
          fallback.hidden = false;
          input.value = url.href;
          input.focus();
          input.select();
        }
      }
    });
    root.addEventListener('keydown', event => {
      const tab = event.target.closest('[data-color-tab]');
      if (tab && ['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const index = tabs.indexOf(tab);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        tabs[next].click();
      } else if (dialog.open && ['ArrowRight', 'ArrowLeft'].includes(event.key)) {
        event.preventDefault();
        changePhoto(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    selectPhoto(panels[0].querySelector('[data-color-photo]'), false, false);
    selectFromHash();
    renderSaved();
    window.addEventListener('hashchange', selectFromHash);
    if (window.location.hash.startsWith('#' + root.id + '-')) root.scrollIntoView({block: 'start'});
  };
  document.querySelectorAll('[data-color-gallery]').forEach(initColorGallery);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-color-gallery]').forEach(initColorGallery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kcl-final-directory"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-area-directory]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const input=root.querySelector('[data-area-search]'),clear=root.querySelector('[data-area-clear]'),cities=[...root.querySelectorAll('[data-area-city]')],groups=[...root.querySelectorAll('[data-area-group]')],status=root.querySelector('[data-area-status]'),empty=root.querySelector('[data-area-empty]'),label=root.dataset.areaLabel||'';const update=()=>{const q=input.value.trim().toLocaleLowerCase();cities.forEach(city=>city.hidden=!city.dataset.areaCity.toLocaleLowerCase().includes(q));groups.forEach(group=>{const all=[...group.querySelectorAll('[data-area-city]')],visible=all.filter(city=>!city.hidden),count=group.querySelector('[data-area-group-count]');group.hidden=q!==''&&visible.length===0;if(count)count.textContent=q!==''?visible.length+'/'+all.length:all.length;if(q!=='')group.open=visible.length>0;else if(root.dataset.hadSearch==='true')group.open=false;});const total=cities.filter(city=>!city.hidden).length;empty.hidden=total!==0;clear.hidden=q==='';status.textContent=total+' / '+cities.length+' '+label;root.dataset.hadSearch=q!==''?'true':root.dataset.hadSearch;};root.querySelector('[data-area-search-wrap]').hidden=false;input.addEventListener('input',update);clear.addEventListener('click',()=>{input.value='';update();input.focus();});update();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kcl-final-portfolio"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kcl-portfolio]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-work-project]')],filters=[...root.querySelectorAll('[data-work-filter]')],dialog=root.querySelector('[data-work-dialog]'),count=root.querySelector('[data-work-count]');root.querySelector('[data-work-filters]').hidden=false;const select=value=>{cards.forEach(card=>card.hidden=value!=='all'&&card.dataset.workProject!==value);filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.workFilter===value)));count.textContent=cards.filter(card=>!card.hidden).length+' / '+cards.length;};root.addEventListener('click',event=>{const filter=event.target.closest('[data-work-filter]');if(filter){select(filter.dataset.workFilter);return;}const link=event.target.closest('[data-work-open]');if(link&&typeof dialog.showModal==='function'){event.preventDefault();const source=link.querySelector('img'),large=dialog.querySelector('[data-work-large]');large.src=link.href;large.alt=source.alt;dialog.querySelector('[data-work-caption]').textContent=link.closest('article').querySelector('h2').textContent;dialog.showModal();}});select('all');});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kcl-tree-planner"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    var groups=['coverage','light_style','color','add_ons'];
    var labels={};
    groups.forEach(function(group){var fieldset=root.querySelector('[data-plan-group="'+group+'"]');labels[group]=fieldset?fieldset.querySelector('legend').textContent.trim():group;});
    var key='kcl-tree-plan-'+root.id;
    function selected(group){return Array.from(root.querySelectorAll('[data-plan-group="'+group+'"] input:checked')).map(function(input){return input.value;});}
    function render(save){var state={};groups.forEach(function(group){var values=selected(group);state[group]=values;var output=root.querySelector('[data-summary="'+group+'"]');if(output)output.textContent=values.length?values.join(', '):root.dataset.empty;});if(save){try{localStorage.setItem(key,JSON.stringify(state));}catch(error){}}return state;}
    try{var saved=JSON.parse(localStorage.getItem(key)||'{}');groups.forEach(function(group){(saved[group]||[]).forEach(function(value){var match=Array.from(root.querySelectorAll('[data-plan-group="'+group+'"] input')).find(function(input){return input.value===value;});if(match)match.checked=true;});});}catch(error){}
    render(false);
    root.addEventListener('change',function(){render(true);});
    var button=root.querySelector('[data-copy-plan]');
    var status=root.querySelector('[role="status"]');
    if(button)button.addEventListener('click',async function(){var state=render(true);var lines=[root.dataset.copyTitle];groups.forEach(function(group){lines.push(labels[group]+': '+(state[group].length?state[group].join(', '):root.dataset.empty));});var copy=lines.join('\n');try{await navigator.clipboard.writeText(copy);status.textContent=root.dataset.copied;}catch(error){var area=document.createElement('textarea');area.value=copy;area.setAttribute('readonly','');area.style.position='fixed';area.style.opacity='0';document.body.appendChild(area);area.select();document.execCommand('copy');area.remove();status.textContent=root.dataset.copied;}});
  }
  function boot(){document.querySelectorAll('[data-tree-planner]').forEach(setup);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot,{once:true});}else{boot();}
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-tree-planner]').forEach(setup);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["santa-concierge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kcl-santa-concierge')) {
    customElements.define('kcl-santa-concierge', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.log = this.querySelector('[role="log"]');
        this.status = this.querySelector('[role="status"]');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.ask(); });
        this.querySelectorAll('[data-question]').forEach(button => button.addEventListener('click', () => {
          if (this.busy) return;
          this.input.value = button.textContent;
          this.form.requestSubmit();
        }));
        this.querySelector('.kcl-santa-reset').addEventListener('click', () => {
          if (this.busy) return;
          this.state = undefined;
          this.log.replaceChildren();
          this.status.textContent = '';
          this.querySelector('.kcl-santa-fallback').hidden = true;
          this.input.value = '';
          this.input.focus();
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
      message(label, content) {
        const article = document.createElement('article');
        const heading = document.createElement('strong');
        heading.textContent = label;
        article.append(heading);
        content.filter(value => typeof value === 'string' && value).forEach(value => {
          const p = document.createElement('p'); p.textContent = value.slice(0, 2200); article.append(p);
        });
        this.log.append(article);
        while (this.log.children.length > 12) this.log.firstElementChild.remove();
        return article;
      }
      async ask() {
        const question = this.input.value.trim().slice(0, 500);
        if (this.busy || question.length < 2) return;
        this.busy = true;
        this.querySelector('.kcl-santa-fallback').hidden = true;
        this.querySelectorAll('button').forEach(button => { button.disabled = true; });
        this.message(this.dataset.you, [question]);
        this.status.textContent = this.dataset.loading;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 15000);
        try {
          const response = await fetch('https://directory.christmascontractor.com/api/product-help', {
            method: 'POST', mode: 'cors', credentials: 'omit', signal: this.controller.signal,
            headers: { 'content-type': 'application/json', 'x-kingdom-ai-channel': 'kingdom_christmas_lights' },
            body: JSON.stringify({ question, channel: 'kingdom_christmas_lights', projectState: this.state })
          });
          if (!response.ok) throw new Error('unavailable');
          const answer = await response.json();
          if (typeof answer.directAnswer !== 'string') throw new Error('invalid response');
          this.state = answer.projectState;
          const article = this.message(this.dataset.santa, [answer.directAnswer, answer.why, answer.nextStep, answer.followUpQuestion]);
          const allowed = new Set([
            '/', '/pages/estimate', '/pages/residential', '/pages/commercial', '/pages/permanent',
            '/pages/tree-wrapping', '/pages/service-removal-storage', '/pages/service-area',
            '/pages/contact', '/pages/terms-and-conditions', '/pages/houston-tx',
            '/pages/the-woodlands-tx', '/pages/montgomery-tx', '/pages/conroe-tx',
            '/pages/cypress-tx', '/pages/katy-tx', '/pages/tomball-tx', '/pages/magnolia-tx',
            '/pages/spring-tx', '/pages/sugar-land-tx', '/pages/missouri-city-tx',
            '/pages/richmond-tx', '/pages/rosenberg-tx', '/pages/fulshear-tx',
            '/pages/college-station-tx', '/pages/bryan-tx', '/pages/huntsville-tx',
            '/pages/kingwood-tx', '/pages/pearland-tx', '/pages/league-city-tx',
          ]);
          (Array.isArray(answer.ctas) ? answer.ctas : []).slice(0, 3).forEach(cta => {
            try {
              const url = new URL(cta.href, 'https://kingdomchristmaslights.com');
              if (url.protocol !== 'https:' || !['kingdomchristmaslights.com', 'www.kingdomchristmaslights.com'].includes(url.hostname) || url.port || url.username || url.password || !allowed.has(url.pathname) || url.search) return;
              if (typeof cta.label !== 'string') return;
              const a = document.createElement('a'); a.href = url.pathname + url.hash; a.textContent = cta.label.slice(0, 100); article.append(a);
            } catch {}
          });
          this.input.value = '';
          this.status.textContent = '';
        } catch {
          this.status.textContent = this.dataset.unavailable;
          this.querySelector('.kcl-santa-fallback').hidden = false;
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.querySelectorAll('button').forEach(button => { button.disabled = false; });
          this.input.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
